import React, { useState } from 'react';

import { Grid } from '@material-ui/core';

import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import { KPIData } from '../types';
import { KPI_COLORS, KPI_THEME } from '../analytics-dashboard/constants/dashboard-theme';
import { PeriodTabs, PeriodTab, ColoredCard, KPIHeader, CardTitle, KPIValue, KPISubTitle, KPIIconCircle } from '../analytics-dashboard/dashboard.styles';
import { Tabs, Tab } from '@material-ui/core';
import KPICard from './KPICards';


interface Props {
  kpiData: KPIData;
  period: 'week' | 'month';
  action: string;
  onPeriodChange: (period: 'week' | 'month') => void;
}

const KPICards = ({ kpiData ,period,action,onPeriodChange}: Props) => {
  //const [period, setPeriod] = useState<'week' | 'month'>('week');

  const data = period === 'week'
    ? kpiData.week
    : kpiData.month;

  /*   console.log({
  period,
  onPeriodChange,
}); */

  const cards = [
    {
      title: 'Total Operations',
      value: data.total,
      subtitle: period === 'week' ? 'Last 7 Days' : 'Last 30 Days',
      icon: (
        <AssessmentOutlinedIcon
          style={{ color: KPI_THEME.total.color }}
        />
      ),
      ...KPI_THEME.total,
    },

    {
      title: 'Added',
      value: data.added,
      subtitle: period === 'week' ? 'Last 7 Days' : 'Last 30 Days',
      icon: (
        <AddCircleOutlineIcon
          style={{ color: KPI_THEME.added.color }}
        />
      ),
      ...KPI_THEME.added,
    },

    {
      title: 'Modified',
      value: data.modified,
      subtitle: period === 'week' ? 'Last 7 Days' : 'Last 30 Days',
      icon: (
        <EditOutlinedIcon
          style={{ color: KPI_THEME.modified.color }}
        />
      ),
      ...KPI_THEME.modified,
    },

    {
      title: 'Deleted',
      value: data.deleted,
      subtitle: period === 'week' ? 'Last 7 Days' : 'Last 30 Days',
      icon: (
        <DeleteOutlineIcon
          style={{ color: KPI_THEME.deleted.color }}
        />
      ),
      ...KPI_THEME.deleted,
    },
  ];

  

  return (
    <>
      <Tabs
        value={period}
        indicatorColor="primary"
        textColor="primary"
  onChange={(e, value) => onPeriodChange(value)}
        style={{ marginBottom: 24 }}
      >
        <Tab label="Last 7 Days" value="week" style={{fontWeight:600}}/>
        <Tab label="Last 30 Days" value="month" style={{fontWeight:600}}/>
      </Tabs>

      <Grid container spacing={3} style={{marginBottom:20}}>
        {cards.map(card => {
    const isDisabled =
      action !== "All" &&
      !(
        (action === "Added" && card.title === "Added") ||
        (action === "Modified" && card.title === "Modified") ||
        (action === "Deleted" && card.title === "Deleted")
      );

    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={3}
        key={card.title}
      >
        <KPICard
          {...card}
          disabled={isDisabled}
        />
      </Grid>
    );
  })}
      </Grid>
    </>
  );
};

export default KPICards;